import { motion } from 'framer-motion';

export default function Hero() {
  const handleContactClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const contactSection = document.getElementById('contacto');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleServicesClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const servicesSection = document.getElementById('servicios');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="relative min-h-screen flex items-center justify-center overflow-hidden bg-white">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/451627f833a7df46d5adeb9b91ce6c44.jpg"
          alt="Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-20 sm:py-32 w-full">
        <div className="text-center text-white">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="inline-flex items-center gap-2 px-4 sm:px-6 py-2 sm:py-3 bg-white/10 backdrop-blur-md rounded-full mb-6 sm:mb-8 border border-white/20"
          >
            <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
            <span className="text-xs sm:text-sm font-medium">Automatización SEO con IA Generativa</span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-4 sm:mb-6 leading-tight px-4"
          >
            Posiciona tu Web en
            <br />
            <span className="text-gray-300">
              Google, ChatGPT, Gemini y más
            </span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-lg sm:text-xl md:text-2xl mb-8 sm:mb-12 text-white/90 max-w-4xl mx-auto leading-relaxed px-4"
          >
            Optimización SEO técnica avanzada con Inteligencia Artificial que mejora tu ranking en 
            Google, Bing, ChatGPT, Gemini, Perplexity y todos los agentes de IA. Aumenta tu visibilidad 
            en buscadores tradicionales y en la nueva era de búsqueda conversacional
          </motion.p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="#contacto"
              onClick={handleContactClick}
              className="px-8 py-4 bg-cyan-500 text-white rounded-lg font-medium text-lg hover:bg-cyan-600 hover:shadow-xl transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Solicitar Consulta Gratuita
            </a>
            <a 
              href="#servicios"
              onClick={handleServicesClick}
              className="px-8 py-4 bg-white text-gray-900 rounded-lg font-medium text-lg hover:bg-gray-50 hover:shadow-xl transition-all duration-300 whitespace-nowrap cursor-pointer border-2 border-gray-200"
            >
              Ver Servicios
            </a>
          </div>

          {/* Stats */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-8 max-w-5xl mx-auto px-4"
          >
            {[
              { value: '+500', label: 'Sitios Optimizados', icon: 'ri-global-line' },
              { value: '98%', label: 'Satisfacción', icon: 'ri-star-fill' },
              { value: '+250%', label: 'Tráfico Medio', icon: 'ri-line-chart-line' },
              { value: '24/7', label: 'Soporte', icon: 'ri-customer-service-2-line' }
            ].map((stat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: 1 + index * 0.1 }}
                className="bg-white/10 backdrop-blur-md rounded-lg p-4 sm:p-6 border border-white/20 hover:bg-white/20 transition-all duration-300"
              >
                <i className={`${stat.icon} text-2xl sm:text-3xl text-white mb-2`}></i>
                <div className="text-2xl sm:text-3xl md:text-4xl font-bold mb-1">{stat.value}</div>
                <div className="text-xs sm:text-sm text-white/80">{stat.label}</div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10"
      >
        <div className="flex flex-col items-center gap-2 text-white/80">
          <span className="text-xs sm:text-sm">Descubre más</span>
          <i className="ri-arrow-down-line text-xl sm:text-2xl"></i>
        </div>
      </motion.div>
    </header>
  );
}
